/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Date: 1/18/22
 * Copyright All Rights Reserved
 */
import React from 'react';
import { Field } from 'redux-form';
import classNames from 'classnames';
import RenderSelect from './RenderSelect';

/**
 * States
 * @type {Object[]}
 */
const SITE_CLASSES = [
  {
    siteClass: 'A',
    value: '2000',
  },
  {
    siteClass: 'B',
    value: '1150',
  },
  {
    siteClass: 'B/C',
    value: '760',
  },
  {
    siteClass: 'C',
    value: '537',
  },
  {
    siteClass: 'C/D',
    value: '360',
  },
  {
    siteClass: 'D',
    value: '259',
  },
  {
    siteClass: 'D/E',
    value: '180',
  },
];

/**
 * States
 * @type {Object[]}
 */
const options = [
  {
    id: 'usgs',
    name: 'U.S Geological Survey',
  },
  {
    id: 'cgs',
    name: 'California Geological Survey (CA only)',
  },
  ...SITE_CLASSES.map(x => ({ id: x.value, name: `Site Class ${x.siteClass}` })),
];

/**
 * Defines a select menu for Site Class
 * @constructor
 */
const SiteClassSelect = () => {
  const ddlOptions = options.map(
    o => <option key={`site-class-option-${o.id}`} value={o.id}>{o.name}</option>
  );
  return (
    <Field
      label="Site Class"
      className={classNames('form-control', 'site-class-select')}
      id="siteClass"
      name="siteClass"
      component={RenderSelect}
    >
      {ddlOptions}
    </Field>
  );
};

export default SiteClassSelect;
